export const NAME = 'template-render';

export const PROPOSAL_TYPE = 'proposal-type';
